import { useSelectedConfigTab } from '@atlassian/jira-software-board-settings-rapidboard-config-common/src/controllers/use-selected-config-tab/index.tsx';
import { useQueryParam } from '@atlassian/react-resource-router';

export const InsightsSettingsRedirect = () => {
	const { setSelectedConfigTab } = useSelectedConfigTab();
	const [, setConfigParam] = useQueryParam('config');
	setSelectedConfigTab('filter');
	setConfigParam('filter');

	return null;
};
